module.exports = __webpack_public_path__ + "static/img/s5.324b534.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/s5.png
// module id = 4Khg
// module chunks = 1